import CreateFaqDrawer from './CreateFaqDrawer.component';

export default CreateFaqDrawer;